import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from './../../../services/modal/modal.service';

interface OptionInput {
  name: string;
  action: () => Promise<void>;
}

@Component({
  selector: 'app-select-option',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss'],
})
export class SelectOptionModalComponent implements OnInit {

  constructor(private modalService: ModalService) { }

  @Input() options: OptionInput[] = [];

  ngOnInit() {}

  onClickOption(option: OptionInput): void {
    option.action().then();
  }

  onClickCancel(): void {
    this.modalService.dismiss();
  }
}
